import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { RequestPagingDto } from "../../../shared/nestjs/gd-only/dto/base.dto";
import { ResponseAttFaceListingDto, RequestGetBasePhotoDto, ResponseGetBasePhotoDto, RequestGetMyRequestDto, ResponseGetMyRequestDto, ResponseGetNeedApprovalDto, RequestProcessApproveDto, RequestConfigFaceRecognizeBaseDto } from "../../../shared/nestjs/gd-only/dto/attendance-face.dto";
import { AttendancesFaceApi } from "../../../shared/nestjs/gd-only/services/attendance-face.api";
import { ResponsePaging } from "../../../shared/nestjs/nest-responses";
import { EmployeesApi } from "../../../shared/nestjs/gd-only/services/employees.api";
import { RequestGetEmpDto, ResponseGetEmpDto } from "../../../shared/nestjs/gd-only/dto/employees.dto";
import { OptionsUploadWithHttp, FileUploaderProvider } from "../../../providers/file-uploader/file-uploader";
import moment from "moment";

@Injectable()
export class AttendanceFaceBloc {
  private subscriptions: Array<Subscription> = [];
  private _needApprove = 0;
  constructor(
    private attendancesFaceApi: AttendancesFaceApi,
    private empNestApi: EmployeesApi,
    private fileUploader: FileUploaderProvider
  ) {
  }

  dispose() {
    this.subscriptions.forEach(item => item.unsubscribe());
  }

  set needApprove(data) {
    this._needApprove = data;
  }

  get needApprove() {
    return this._needApprove;
  }

  async upload(options: OptionsUploadWithHttp) {
    try {
      const url = this.attendancesFaceApi.urlUploadFaceRecognize();
      const result = await this.fileUploader.uploadWithHttpCustom(options, url);
      return result;
    } catch (error) {
      throw error;
    }
  }

  processWebImage(event) {
    return new Promise((resolve) => {
      let name = event.target.files[0].name;
      let fileIMG = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      let formatImage = name.split('.').pop();
      let res = formatImage.toLowerCase();
      let options = moment().valueOf() + '.' + res;
      let type = "image";
      if (fileIMG.indexOf(res) < 0) {
        type = "file"
      }

      let base: any;
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        base = reader.result;
        const result = {
          data: base,
          options: options,
          isSelected: false,
          eventsWebview: <File>event.target.files,
          type: type
        }

        resolve(result);
      }, false);
      reader.readAsDataURL(event.target.files[0]);
    })
  }
  
  async doGetNeedApproval() {
    try {
      const response = await this.getNeedApproval({ limit: 1, page: 1 });
      this.needApprove = response.total;
    } catch (error) { }
  }

  listing(payload: { empId: string }, queryParams: RequestPagingDto) {
    return new Promise<ResponsePaging<ResponseAttFaceListingDto>>((resolve, reject) => {
      this.subscriptions.push(
        this.attendancesFaceApi.listing(payload, queryParams)
          .subscribe(result => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  getBasePhoto(payload: RequestGetBasePhotoDto) {
    return new Promise<ResponseGetBasePhotoDto>((resolve, reject) => {
      this.subscriptions.push(
        this.attendancesFaceApi.getBasePhoto(payload)
          .map(response => response.data)
          .subscribe(result => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    });
  }

  getMyRequest(payload: RequestGetMyRequestDto) {
    return new Promise<ResponseGetMyRequestDto>((resolve, reject) => {
      this.subscriptions.push(
        this.attendancesFaceApi.getMyRequest(payload)
          .map(response => response.data)
          .subscribe(result => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    });
  }

  getNeedApproval(payload: RequestPagingDto) {
    return new Promise<ResponsePaging<ResponseGetNeedApprovalDto>>((resolve, reject) => {
      this.subscriptions.push(
        this.attendancesFaceApi.getNeedApproval(payload)
          .subscribe(result => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    });
  }

  processApprove(payload: RequestProcessApproveDto[]) {
    return new Promise<any>((resolve, reject) => {
      this.subscriptions.push(
        this.attendancesFaceApi.processApprove(payload)
          .subscribe(result => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    });
  }

  configFaceRecognizeBase(payload: RequestConfigFaceRecognizeBaseDto) {
    return new Promise<any>((resolve, reject) => {
      this.subscriptions.push(
        this.attendancesFaceApi.configFaceRecognizeBase(payload)
          .map(res => res.data)
          .subscribe(result => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    });
  }

  getEmp(body: RequestGetEmpDto, queryParams) {
    return new Promise<ResponsePaging<ResponseGetEmpDto>>((resolve, reject) => {
      this.subscriptions.push(
        this.empNestApi.getEmp(body, queryParams)
          .subscribe(result => {
            resolve(result);
          }, error => {
            reject(error);
          })
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/bloc/hr/attendance/attendance-face.bloc.ts